<template>
  <span class="IconBase">
    <component :is="iconName" />
  </span>
</template>

<script>
import AddIcon from './Icon/AddIcon.vue';
import AppIcon from './Icon/AppIcon.vue';
import CalendarIcon from './Icon/CalendarIcon.vue';
import CancelIcon from './Icon/CancelIcon.vue';
import CheckCircleIcon from './Icon/CheckCircleIcon.vue';
import CloseIcon from './Icon/CloseIcon.vue';
import DownIcon from './Icon/DownIcon.vue';
import DropDownIcon from './Icon/DropDownIcon.vue';
import DropUpIcon from './Icon/DropUpIcon.vue';
import EditIcon from './Icon/EditIcon.vue';
import ErrorIcon from './Icon/ErrorIcon.vue';
import GroupIcon from './Icon/GroupIcon.vue';
import HelpIcon from './Icon/HelpIcon.vue';
import HomeIcon from './Icon/HomeIcon.vue';
import LeftIcon from './Icon/LeftIcon.vue';
import ContractIcon from './Icon/ContractIcon.vue';
import MoreIcon from './Icon/MoreIcon.vue';
import NotificationsIcon from './Icon/NotificationsIcon.vue';
import OtherIcon from './Icon/OtherIcon.vue';
import PasswordOffIcon from './Icon/PasswordOffIcon.vue';
import PasswordOnIcon from './Icon/PasswordOnIcon.vue';
import RadioOnIcon from './Icon/RadioOnIcon.vue';
import RadioOffIcon from './Icon/RadioOffIcon.vue';
import RefreshIcon from './Icon/RefreshIcon.vue';
import RightIcon from './Icon/RightIcon.vue';
import SearchIcon from './Icon/SearchIcon.vue';
import SecurityIcon from './Icon/SecurityIcon.vue';
import SendIcon from './Icon/SendIcon.vue';
import ServiceIcon from './Icon/ServiceIcon.vue';
import SortDefaultIcon from './Icon/SortDefaultIcon.vue';
import SortDownIcon from './Icon/SortDownIcon.vue';
import SortUpIcon from './Icon/SortUpIcon.vue';
import SpecteeLogoBlackIcon from './Icon/SpecteeLogoBlack.vue';
import SpecteeLogoBlueIcon from './Icon/SpecteeLogoBlue.vue';
import SpecteeLogoRedIcon from './Icon/SpecteeLogoRed.vue';
import SuccessIcon from './Icon/SuccessIcon.vue';
import UpIcon from './Icon/UpIcon.vue';
import UserIcon from './Icon/UserIcon.vue';
import ExceptionIcon from './Icon/ExceptionIcon.vue';
import DoubleLeftIcon from './Icon/DoubleLeftIcon.vue';
import DoubleRightIcon from './Icon/DoubleRightIcon.vue';
import DeleteIcon from './Icon/DeleteIcon.vue';

export default {
  name: 'IconBase',
  components: {
    Add: AddIcon,
    App: AppIcon,
    Calendar: CalendarIcon,
    Cancel: CancelIcon,
    CheckCircle: CheckCircleIcon,
    Close: CloseIcon,
    Delete: DeleteIcon,
    Down: DownIcon,
    DropDown: DropDownIcon,
    DropUp: DropUpIcon,
    Edit: EditIcon,
    Error: ErrorIcon,
    Group: GroupIcon,
    Help: HelpIcon,
    Home: HomeIcon,
    Left: LeftIcon,
    Contract: ContractIcon,
    More: MoreIcon,
    Notifications: NotificationsIcon,
    Other: OtherIcon,
    PasswordOff: PasswordOffIcon,
    PasswordOn: PasswordOnIcon,
    RadioOn: RadioOnIcon,
    RadioOff: RadioOffIcon,
    Refresh: RefreshIcon,
    Right: RightIcon,
    Search: SearchIcon,
    Security: SecurityIcon,
    Send: SendIcon,
    Service: ServiceIcon,
    SortDefault: SortDefaultIcon,
    SortDown: SortDownIcon,
    SortUp: SortUpIcon,
    SpecteeLogoBlack: SpecteeLogoBlackIcon,
    SpecteeLogoBlue: SpecteeLogoBlueIcon,
    SpecteeLogoRed: SpecteeLogoRedIcon,
    Success: SuccessIcon,
    Up: UpIcon,
    User: UserIcon,
    Exception: ExceptionIcon,
    DoubleLeft: DoubleLeftIcon,
    DoubleRight: DoubleRightIcon,
  },
  props: {
    iconName: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.IconBase {
  display: inline-flex;
}
</style>
